import { createSelector } from 'reselect';
import queryString from 'query-string';

import * as types from '../actions/actionTypes';
import settings from './../settings.json';
import { color2string, string2color } from './../helper/ColorUtils';
import { getPattern } from './patterns';

export const currentPattern = (state, action) => {
    switch (action.type) {
    case types.NAVIGATED_TO_SINGLE_PATTERN_VIEW:
        return Object.assign({}, state, {
            id: action.payload.patternid,
            sewpatId: action.payload.sewpatId,
            sharingImage: null,
        });

    case types.PATTERN_SELECTED:
        return Object.assign({}, state, {
            id: action.patternId,
            sharingImage: null,
        });

    case types.SHARABLE_PRODUCT_IMAGE_SETTED:
        return Object.assign({}, state, {
            sharingImage: action.sharableProductImage,
        });

    default:
        return state;
    }
};

export default currentPattern;

export const getCurrentPatternId = state => state.stolo.selectedPattern.id;
export const getPatterns = state => state.stolo.entities.patterns.entities;

/**
 * Get a currently selected pattern.
 *
 * @param state
 * @param patternid
 * @returns {{}}
 *  A single pattern object.
 */
export const getCurrentPattern = createSelector(
    [getCurrentPatternId, getPatterns],
    (patternid, patterns) => patterns[patternid] || {},
);

/**
 * Get current pattern title.
 *
 * @param state
 * @returns {*}
 */
export const getCurrentPatternTitle = createSelector(
    [getCurrentPatternId, getPatterns],
    (patternid, patterns) => (patterns[patternid] || {}).title || null,
);


/**
 * Returns the current colors of a pattern. Defaults for initialColors if no
 * custom colors are available.
 *
 * @param state
 * @returns {*}
 */
export const getCurrentPatternColors = createSelector(
    [getCurrentPatternId, getPatterns],
    (patternid, patterns) => (patterns[patternid] || {}).colors || [],
);

/**
 * SMELLS. This is not realy a selector. Its utility that builds the
 * the imgUri String against the patterndesign api. Maybe we better place that
 * in the middleware an put it in state.
 *
 * @param state
 * @param sizeInPx
 * @returns {string}
 */
export const getCurrentPatternThumbnailUri = (state, patternid, sizeInPx = 400) => {
    const { id } = state.stolo.selectedPattern;
    const colors = ((state.location.query) || {}).colors ? string2color(((state.location.query) || {}).colors) : undefined;

    let thumb;

    if (id !== patternid) {
        return;
    }

    try {
        if (colors && colors.length > 0) {
            const API_ROOT = `${[settings.AppSettings.patternDesignAPIRoot, settings.AppSettings.patternDesignToken, 'pattern', 'recolor'].join('/')}?`;
            const query = queryString.stringify({
                id,
                waterMarkType: 'discreet',
                resolution: sizeInPx,
                colors: color2string(colors),
            });
            return API_ROOT + query;
        }
        const pattern = getPattern(state, patternid);
        const { thumbnails } = pattern;
        if (sizeInPx === 400) {
            thumb = thumbnails.medium.url;
        }
        else if (sizeInPx > 400) {
            thumb = thumbnails.xlargeDiscreet.url;
        }
        else {
            thumb = thumbnails.gallery.url;
        }
        return thumb;
    }
    catch (e) {
        console.error('Error: Cannot extract an valid thumbnail url.');
    }
};

export const getColoredPatternThumbnailUri = (pattern, colors, sizeInPx = 400) => {
    try {
        const API_ROOT = `${[settings.AppSettings.patternDesignAPIRoot, settings.AppSettings.patternDesignToken, 'pattern', 'recolor'].join('/')}?`;
        const query = queryString.stringify({
            id: pattern.id,
            waterMarkType: 'discreet',
            resolution: sizeInPx,
            colors,
        });
        return API_ROOT + query;
    }
    catch (e) {
        console.log('Error: Cannot extract an valid thumbnail url.');
        return null;
    }

};

export const getSharableProductImage = state => state.stolo.selectedPattern.sharingImage;



// WEBPACK FOOTER //
// ./src/reducers/currentPattern.js